<div [ngClass]="{ disabled: disabled }" class="mat-select-trigger">
  @if (display || placeholder) {
    <span>{{ display ?? placeholder }}</span>
  }
</div>
